<template>
  <div class="plc-msgResult">
    <gl-svg-icon :name="iconName" height="64" width="64" class="plc-msgResult__icon" />
    <p class="plc-msgResult__title">{{ title }}</p>
    <p class="plc-msgResult__text">{{ text }}</p>

    <div v-if="$slots.btn" class="plc-msgResult__btnContainer">
      <slot name="btn" />
    </div>
  </div>
</template>

<script>
import GlSvgIcon from '@gl/GlSvgIcon'

export default {
  name: 'GlMsgResult',
  components: {
    GlSvgIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.plc-msgResult {
  text-align: center;

  &__icon {
    color: $color-gray-4;
  }

  &__title {
    color: #fff;
    font-size: 32px;
    font-weight: 700;
    line-height: 32px;
    margin-top: 32px;
    word-break: break-word;

    @media (min-width: $breakpoint-md) {
      font-size: 32px;
      line-height: 40px;
    }
  }

  &__text {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    line-height: 24px;
    margin-top: 32px;
    word-break: break-word;
  }

  &__btnContainer {
    margin-top: 32px;

    @media (min-width: $breakpoint-md) {
      margin-top: 48px;
    }
  }
}
</style>
